import { InputHTMLAttributes } from 'react'

import { FormInputProps } from 'brief-form'
import { InputHintProps } from 'ui/core/InputHint'

type TextareaOpts = InputHintProps &
  Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'value'> & {
    maxLength?: number
    rows?: number
    'data-qa'?: string
  }

export type TextareaProps = FormInputProps<string | null | undefined | unknown, TextareaOpts>
